import {NoteIcon, SpellBookIcon, Tile} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {useRoute} from '../../lib/routes';
import {SectionSeo} from '../../lib/seo';
import {NamesPage} from './names';
import {SpellbookGenerator} from './spellbook';

import css from './tools-page.module.css';

const ToolsIndex: React.FC = () => (
	<div className={css.page}>
		<SectionSeo section="tools" headingClassName={css.title} />
		<p className={css.lead}>Генераторы для подготовки игры: нажмите на инструмент, чтобы открыть его.</p>
		<ul className={css.grid}>
			<li>
				<Tile
					route="names"
					media={<NoteIcon size={24} />}
					title="Генератор имён"
					description="Имена эльфов, дварфов, гномов и других видов из книг"
				/>
			</li>
			<li>
				<Tile
					route="toolSpellbook"
					media={<SpellBookIcon size={24} />}
					title="Генератор книги заклинаний"
					description="Случайная книга заклинаний волшебника с ценой"
				/>
			</li>
		</ul>
	</div>
);

export const ToolsPage: React.FC = () => {
	const {routeName} = useRoute();

	if (routeName === 'names' || routeName === 'namesSet') return <NamesPage />;

	return <Layout>{routeName === 'toolSpellbook' ? <SpellbookGenerator /> : <ToolsIndex />}</Layout>;
};
